import {
  BookOpen,
  Building2,
  ClipboardList,
  FilePlus2,
  FileText,
  FolderKanban,
  Home,
  UserCog,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { SessionUser } from '../../auth/session-types';
import { can } from '../../lib/permissions';

export interface NavigationItem {
  label: string;
  to: string;
  icon: LucideIcon;
  permission?: string;
  /**
   * Resaltar solo con la ruta exacta (`NavLink end`). fix-50 (F-01 de la Línea J): sin él, en
   * `/separations/new` se resaltaban a la vez «Nueva separación» y «Mis separaciones» (`/separations`).
   */
  end?: boolean;
}

const navigationItems: NavigationItem[] = [
  { label: 'Inicio', to: '/dashboard', icon: Home },
  { label: 'Inmobiliarias', to: '/admin/companies', permission: 'inmobiliaria.ver', icon: Building2 },
  { label: 'Proyectos', to: '/admin/projects', permission: 'proyecto.ver', icon: FolderKanban },
  { label: 'Catálogo', to: '/admin/catalog', permission: 'catalogo.ver', icon: BookOpen },
  { label: 'Asesores', to: '/admin/advisors', permission: 'usuario.ver', icon: Users },
  // fix-60 · S-01: administradores de la inmobiliaria (alta por invitación).
  { label: 'Administradores', to: '/admin/users', permission: 'usuario.ver', icon: UserCog },
  { label: 'Nueva separación', to: '/separations/new', permission: 'separacion.crear', icon: FilePlus2, end: true },
  { label: 'Mis separaciones', to: '/separations', permission: 'separacion.ver_propias', icon: FileText, end: true },
  // HU-WEB-006 · feat-42: consulta administrativa (el alcance entre inmobiliarias lo decide el back, ADR-014).
  { label: 'Separaciones', to: '/admin/separations', permission: 'separacion.ver_todas', icon: ClipboardList },
];

export function visibleNavigation(user: SessionUser): NavigationItem[] {
  return navigationItems.filter((item) => !item.permission || can(user.permissions, item.permission));
}
